import { Phone, CheckCircle } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../components/ui/accordion';
import '../ServicePage.css';

const SportsInjuryService = () => {
  const whatsappUrl = 'https://wa.me/919886332528';

  const conditions = [
    'Sprains and strains',
    'Ligament tears (ACL, MCL, etc.)',
    'Tennis elbow and golfer\'s elbow',
    'Runner\'s knee and shin splints',
    'Shoulder injuries (rotator cuff)',
    'Ankle sprains',
    'Muscle tears and contusions',
    'Overuse injuries'
  ];

  const equipment = ['Sports taping', 'Resistance bands', 'Balance training equipment', 'TENS/IFT therapy', 'Ultrasound therapy'];

  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>Sports Injury Rehabilitation</h1>
          <p className="service-subtitle">Get back to peak performance with expert sports physiotherapy</p>
        </div>
      </div>

      <section className="section">
        <div className="container service-container">
          <div className="service-content">
            <h2>What is Sports Injury Rehabilitation?</h2>
            <p>Sports injury rehabilitation is specialized physiotherapy designed to help athletes and active individuals recover from sports-related injuries and return to their sport safely and quickly. We use sport-specific exercises and advanced techniques to restore strength, flexibility, and performance.</p>

            <h2>Conditions We Treat</h2>
            <ul className="conditions-list">
              {conditions.map((condition, index) => (
                <li key={index}>
                  <CheckCircle size={20} />
                  <span>{condition}</span>
                </li>
              ))}
            </ul>

            <h2>What to Expect at Our Clinic</h2>
            <p>We conduct a comprehensive assessment including movement analysis, strength testing, and sport-specific functional tests. Your rehabilitation program will be tailored to your sport and goals, focusing on safe return to activity with reduced risk of re-injury.</p>

            <h2>Equipment Used</h2>
            <div className="equipment-tags">
              {equipment.map((item, index) => (
                <span key={index} className="equipment-tag">{item}</span>
              ))}
            </div>

            <div className="service-cta">
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-primary">
                <Phone size={20} />
                Book Appointment on WhatsApp
              </a>
            </div>

            <h2>Frequently Asked Questions</h2>
            <Accordion type="single" collapsible className="service-faq">
              <AccordionItem value="item-1">
                <AccordionTrigger>When can I return to sports after an injury?</AccordionTrigger>
                <AccordionContent>
                  Return-to-sport timing depends on your specific injury and recovery progress. We use objective criteria including strength, range of motion, and functional tests to determine when it's safe to return. Rushing back can lead to re-injury.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-2">
                <AccordionTrigger>Do you work with professional athletes?</AccordionTrigger>
                <AccordionContent>
                  Yes, we work with athletes at all levels - from weekend warriors to competitive and professional athletes. Our physiotherapists understand the demands of different sports and create appropriate rehabilitation programs.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-3">
                <AccordionTrigger>Can you help prevent future injuries?</AccordionTrigger>
                <AccordionContent>
                  Absolutely! Injury prevention is a key part of our sports physiotherapy. We identify risk factors and provide exercises and techniques to strengthen weak areas and improve movement patterns to reduce injury risk.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-4">
                <AccordionTrigger>Should I stop training completely during rehabilitation?</AccordionTrigger>
                <AccordionContent>
                  Not necessarily. We'll guide you on modified training that allows healing while maintaining fitness. Complete rest is rarely needed - we'll help you stay active safely during recovery.
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SportsInjuryService;